const sliderText = () => {
    const sections = document.querySelectorAll('.slider-text');
    if (!sections.length) return;

    sections.forEach(section => {
        const slider = section.querySelector('.slider-text__swiper');
        if (!slider) return;

        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            autoplay: false,
            pagination: {
                el: section.querySelector('.slider-text__pagination'),
                type: 'fraction',
            },
            navigation: {
                prevEl: section.querySelector('.slider-text__btn-prev'),
                nextEl: section.querySelector('.slider-text__btn-next'),
            },
        });
    });
};

export default sliderText;
